/**
 * 환경별 파비콘 색상 설정
 *
 * local: 회색, staging: 틸, live: 검정
 */

import { detectRuntimeEnvFromBrowser } from "@/lib/config/runtimeEnv";

const ENV_COLORS: Record<string, string> = {
  local: "#9e9e9e",
  staging: "#00897b",
  live: "#000000",
};

function buildFaviconSvg(color: string): string {
  return [
    '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" fill="none">',
    `  <rect width="32" height="32" rx="6" fill="${color}"/>`,
    '  <text x="16" y="22" text-anchor="middle" fill="white" font-size="14" font-weight="bold">GGC</text>',
    "</svg>",
  ].join("\n");
}

export function updateFavicon(beEnv?: string) {
  const runtimeEnv = detectRuntimeEnvFromBrowser();
  let color: string;
  if (runtimeEnv === "local") {
    color = ENV_COLORS.local;
  } else if (beEnv) {
    color = beEnv === "production" ? ENV_COLORS.live : ENV_COLORS.staging;
  } else {
    color = ENV_COLORS[runtimeEnv];
  }
  const svg = buildFaviconSvg(color);
  const blob = new Blob([svg], { type: "image/svg+xml" });
  const url = URL.createObjectURL(blob);

  let link = document.querySelector<HTMLLinkElement>('link[rel="icon"]');
  if (!link) {
    link = document.createElement("link");
    link.rel = "icon";
    document.head.appendChild(link);
  }
  link.type = "image/svg+xml";
  link.href = url;
}
